import PlaceMap from "app/PlaceMap";
import PlaceList from "app/PlaceList";
import { createBrowserRouter } from "react-router-dom";
import Home from "app/Home";

export default createBrowserRouter([
    {
        path: "/",
        element: <Home />,
    },
    {
        path: "/place-map",
        element: <PlaceMap />,
    },
    {
        path: "/place-list",
        element: <PlaceList />,
    }
])